type VersionLabel = "CURRENT" | "SUPERCEDED";

interface VersionData {
  changeDescription: string;
  isPayloadVersion: boolean;
  lastPublishDateTimeMillis: number;
  url: string;
  version: string;
  versionLabel: VersionLabel;
}

class Version {
  changeDescription: string;
  isPayloadVersion: boolean;
  lastPublishDateTimeMillis: number;
  url: string;
  version: string;
  versionLabel: VersionLabel;

  constructor(version: VersionData) {
    this.changeDescription = version.changeDescription;
    this.isPayloadVersion = version.isPayloadVersion;
    this.lastPublishDateTimeMillis = version.lastPublishDateTimeMillis;
    this.url = version.url;
    this.version = version.version;
    this.versionLabel = version.versionLabel;
  }
}

export default Version;
